import React from 'react';
import { BannerInvitePartner } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';

import { showModal, closeModal, setLastRequestTime } from '../../Utils';
import api from '../../actions/EndPoints';
import axiosInstance from '../../actions/AxiosInstance';
import { dispatchOverlayLoad } from '../shared/Analytics';

import { isValidPinNumber } from '../shared/Validation';
import { GENERAL_HUB_ERROR_MODAL, HUB_GENERAL_ERROR_OVERLAY } from '../../Constants';

const PostConsentInvitePartner = ({ state }) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [invitePayload, setInvitePayload] = React.useState(null);
    const [fieldsError, setFieldsError] = React.useState(false);
    const [partnerEmail, setEmail] = React.useState('');
    const [partnerPin, setPin] = React.useState('');
    const POST_INVITE_MODAL = "post-consent-invite-partner-modal";

    const getValidEmail = (email) => /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+.[a-zA-Z]{2,4}$/.test(email);

    const emailRoot = document?.querySelectorAll(`[id="partner-email"]`)[0];
    const pinRoot = document?.querySelectorAll(`[id="partner-pin"]`)[0];

    const emailProspControl = document.querySelectorAll('prosp-beacon-control')[0];
    const pinProspControl = document.querySelectorAll('prosp-beacon-control')[1];

    React.useEffect(() => {
        if (fieldsError && !partnerEmail) {
            emailRoot?.internals && emailRoot?.internals?.checkValidity();
        }
        if (fieldsError && !partnerPin) {
            pinRoot?.internals && pinRoot?.internals?.checkValidity();
        }

        if (partnerEmail && !getValidEmail(partnerEmail)) {
            emailProspControl.setAttribute('invalid', '');
        }

        if (partnerPin && !isValidPinNumber(partnerPin)) {
            pinProspControl.setAttribute('invalid', '');
        }

        if (getValidEmail(partnerEmail)) {
            emailProspControl.removeAttribute('invalid');
        }
        if (isValidPinNumber(partnerPin)) {
            pinProspControl.removeAttribute('invalid');
        }

        if (
            partnerEmail &&
            partnerPin &&
            getValidEmail(partnerEmail) &&
            isValidPinNumber(partnerPin)
        ) {
            setFieldsError(false);
        }
    }, [partnerEmail, partnerPin, fieldsError]);

    const handleInvitePartner = () => {
        const isValidEmail = getValidEmail(partnerEmail);
        const isValidPin = isValidPinNumber(partnerPin);

        if (isValidEmail && isValidPin) {
            setFieldsError(false);
            postInvitePartner().then(() => setIsLoading(false));
        }

        if (!isValidEmail) {
            setFieldsError(true);
            emailProspControl.setAttribute('invalid', '');
        }

        if (!isValidPin) {
            setFieldsError(true);
            pinProspControl.setAttribute('invalid', '');
        }
    };

    async function postInvitePartner() {
        setIsLoading(true);
        try {
            const postCall = await axiosInstance.post(
                api.inviteCoClientAPI,
                {
                    emailAddress: invitePayload?.partnerEmail,
                    invitePinNumber: invitePayload?.partnerPin,
                },
                {
                    headers: { apikey: `${state?.apiKey}` },
                }
            );

            if (postCall) {
                setLastRequestTime();
                openConfirmationModal();
                setIsLoading(false);
            }
        } catch (error) {
            const showErrorModalPromise = Promise.resolve(showModal('co-client-failure-hub-error-modal'));
            showErrorModalPromise
                .then(() => console.log(error))
                .then(() => dispatchOverlayLoad('Co-Client Email Failure'))
                .then(() => setLastRequestTime())
                .then(() => setIsLoading(false))
                .then(() => closeModal(POST_INVITE_MODAL));
        }
    }

    const handleMaybeLater = () => {
        try {
            closeModal(POST_INVITE_MODAL);
            window.location.replace('/usis/advice/fps/profile');
        } catch (error) {
            const showErrorModalPromise = Promise.resolve(showModal(GENERAL_HUB_ERROR_MODAL));
            showErrorModalPromise
                .then(() => console.log(error))
                .then(() => dispatchOverlayLoad(HUB_GENERAL_ERROR_OVERLAY))
                .then(() => setLastRequestTime())
                .then(() => setIsLoading(false))
                .then(() => closeModal(POST_INVITE_MODAL));
        }
    };

    const openConfirmationModal = () => {
        showModal('post-consent-invite-confirmation-modal');
        dispatchOverlayLoad('Invite Partner Confirmation Modal');
        closeModal(POST_INVITE_MODAL);
    };

    React.useEffect(() => {
        setInvitePayload({
            partnerEmail,
            partnerPin,
        });
    }, [partnerEmail, partnerPin]);

    return (
        <BannerInvitePartner
            id={'post-consent-invite-partner'}
            leftBtnText={'Maybe Later'}
            loadingTitle={'Inviting partner...'}
            loadingText={'One moment while we invite your partner...'}
            isLoading={isLoading}
            createClick={() => handleInvitePartner()}
            cancelClick={() => handleMaybeLater()}
            setEmail={setEmail}
            setPin={setPin}
            email={partnerEmail}
            pin={partnerPin}
            noCloseButton
        />
    );
};

export default PostConsentInvitePartner;
